import BrandProfile from "./brand-profile";

export default BrandProfile;
